import Button from "../Button/Button"
import './footer.scss';
import { useState, useEffect, useContext } from "react";
import LanguageContext from "../../Contexts/Language";

type FooterProps = {
    height?: number
}

const Footer = (props: FooterProps) =>{
    const {language} = useContext(LanguageContext);
    const emoji = ["❤️","✨","🔥"]
    const [tick, setTick] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setTick(t => (t + 1) % 3);
        }, 1000);
    },[])
    return(
        <div className="footer" style={{height: `${props.height || 85}px`}}>
            <div className="made">{language.footer.made[0]}<p>{emoji[tick]}</p>{language.footer.made[1]}</div>
                <div className="line">
                    <Button className="link source" href="https://gitlab.com/gwarnickn/my-portfolio">{language.footer.source}</Button>
                    <Button className="link credits" href="/credits" sameWindow>{language.footer.credits}</Button>
                </div>
            <div className="copyright">{language.footer.copyright}</div>
        </div>
    )
}
export default Footer;